module.exports = __webpack_public_path__ + "static/visual_1_3_dont-2f00551eba752ba32761f87d2ac2a863.png";